import React, { useMemo } from "react";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
} from "@tanstack/react-table";

// Simple validation function
const validateCell = (key, value) => {
  if (key === "amt") {
    if (isNaN(value)) return "Amount must be a number";
    if (value < 0) return "Amount cannot be negative";
  }
  if (["dealerName", "stateName", "cityName"].includes(key)) {
    if (!value || value.trim() === "") return `${key} is required`;
  }
  return null; // no error
};

const SpareSalesStateWiseTable = ({ data }) => {
  // Dynamically build columns based on keys
  const columns = useMemo(() => {
    if (!data || data.length === 0) return [];

    return Object.keys(data[0]).map((key) => ({
      accessorKey: key,
      header: key,
      cell: ({ getValue }) => {
        const value = getValue();
        const error = validateCell(key, value);

        return (
          <div className="flex flex-col">
            <span className="text-sm">{value?.toString()}</span>
            {error && (
              <span className="text-red-500 text-xs mt-1">{error}</span>
            )}
          </div>
        );
      },
    }));
  }, [data]);

  const table = useReactTable({
    data: data || [],
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  if (!data || data.length === 0) {
    return <p className="text-gray-500">No data available</p>;
  }

  return (
    <div className="border w-full max-w-[400px] h-auto max-h-[320px] overflow-x-auto overflow-y-auto">
      <table className="border border-gray-300 w-full text-sm">
        <thead className="bg-gray-100 sticky top-0 z-10">
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <th
                  key={header.id}
                  className="px-1 border text-left font-semibold bg-gray-100 text-sm"
                >
                  {flexRender(
                    header.column.columnDef.header,
                    header.getContext()
                  )}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map((row) => (
            <tr key={row.id} className="hover:bg-gray-50">
              {row.getVisibleCells().map((cell) => (
                <td key={cell.id} className="p-1 border text-sm">
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SpareSalesStateWiseTable;
